import React, { Component } from 'react';
import { Row, Col, InputGroup, Form } from 'react-bootstrap';
import '../stylesheets/Result.css';

class Result extends Component {

    render() {
        let { convertedResult, currency, isMobile } = this.props;
        return (
            <Row className="text-right mt-3">

                <Col>
                    {isMobile ?
                        <InputGroup className="d-block" >
                            <InputGroup.Prepend className="d-block" >
                                <InputGroup.Text id="amount" className="d-block custom-input-height">
                                    {convertedResult === '' ? currency : convertedResult}
                                </InputGroup.Text>
                            </InputGroup.Prepend>
                        </InputGroup>
                        :
                        <Form>
                            <Form.Control type="text" id="amount" className={'custom-align-center'} value={convertedResult === '' ? currency : convertedResult} onKeyDown={this.props.handleKeyPress} onChange={this.props.handleChange} />
                        </Form>
                    }
                </Col>

            </Row>
        );
    }
}

export default Result;